import React from 'react';
import CreateSchoolScreenEnhanced from '../../src/screens/admin/CreateSchoolScreenEnhanced';

export const options = {
  headerShown: false,
};

export default function CreateSchoolRoute() {
  return <CreateSchoolScreenEnhanced />;
}
